import { Stack } from '@mui/material';
import { FileUpload, RadioButtons } from 'Components';
import { yesNoOptions } from 'Constants';
import { Dictionary } from 'Dictionary';
import { DICTIONARY, FileCategories } from 'Enum';
import { useDictionary } from 'Hooks';
import { IndexContext } from 'Modules/CaseDetails/CaseContext';
import { useContext } from 'react';
import { useWatch } from 'react-hook-form';

export const OtherDocuments = () => {
  const { index, fieldId } = useContext(IndexContext);

  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);

  const baseName = `caseDetails.${index}`;

  const [areThereMedicalDocuments] = useWatch({
    name: [`${baseName}.areOtherRelevantFiles`],
  });

  return (
    <Stack gap='32px'>
      <RadioButtons
        id={dictionary.sixthSectionExtraFilesQ}
        name={`${baseName}.areOtherRelevantFiles` as const}
        options={yesNoOptions}
      />
      {areThereMedicalDocuments && (
        <FileUpload
          caseDetailsId={fieldId}
          fileLabel={dictionary.sixthSectionFile}
          fileCategoryId={FileCategories.OtherRelatedFile}
          ariaLabel={dictionary.sixthSectionFile}
          dataRequired
        />
      )}
    </Stack>
  );
};
